<template>
  <div v-if="self.isShow" class="full-screen-popup column">
    <div class="selectStoreTitle row flex-center">
      <div class="iconfont icon-arr backicon" @click="backClick()"></div>
      <div class="select-title-main flex-1">
        <template v-if="headerTitleFull">
          <span class="title-text">{{ headerTitleFull }}</span>
        </template>
        <template v-else>
          <span class="titleGeay" v-if="self.title">{{ self.title }}</span>
          <span class="title-plain">选择员工</span>
        </template>
      </div>
    </div>

    <div class="searchbar">
      <van-search
        placeholder="输入关键字进行查询"
        @input="debouncedEditShopname()"
        @clear="debouncedEditShopname()"
        v-model="searchContent"
      />
    </div>

    <div ref="listScroll" class="overflow-y flex-1 listScroll">
      <div class="shoplist">
        <!-- 空选项，支持清空 -->
        <div
          v-if="showNone"
          class="shop-item row flex-center"
          :class="current === '' ? 'active' : ''"
          @click="
            clickStore({
              value: '',
              name: '',
            })
          "
        >
          <div class="flex-1">无</div>
          <div
            class="iconfont icon-ok"
            :class="current === '' ? 'active' : ''"
          ></div>
        </div>
        <!-- 下拉列表数据 -->
        <div
          class="shop-item row flex-center"
          :class="{
            active: row.value == current,
            disabled: row.disabled,
          }"
          v-for="(row, index) in list"
          :key="index"
          @click="clickStore(row)"
        >
          <div class="flex-1">
            {{ row.name }}
          </div>
          <div
            class="iconfont icon-ok"
            :class="row.value == current ? 'active' : ''"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import debounceTool from "@/util/debounce.js";
import PinyinMatch from "pinyin-match";
import func from "@/util/func.js";

export default {
  name: "selectEmployee",
  props: {
    self: {
      type: Object,
      required: false,
      default: () => ({
        isShow: false,
        current: "",
        /** 完整头部标题（优先）；与 title 灰字前缀 +「选择员工」二选一 */
        headerTitle: "",
      }),
    },
    topTitle: {
      type: String,
      default: "",
    },
    options: {
      type: Array,
      required: false,
      default: () => [],
    },
    showNone: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      searchContent: "",
      list: [],
      listBack: [],
      current: "",
    };
  },
  computed: {
    /** 父级传入的整行标题（如「选择预约医生」） */
    headerTitleFull() {
      const t = this.self?.headerTitle;
      return t != null && String(t).trim() !== "" ? String(t).trim() : "";
    },
  },
  mounted() {
    this.format();
    // 创建防抖版本的搜索方法，尾部执行，避免快速输入时的频繁搜索
    this.debouncedEditShopname = debounceTool._debounce(this.editShopname, 300);
    this.$nextTick(() => this.scrollToSelected());
  },
  methods: {
    format() {
      const that = this;
      that.current = that.self.current;
      that.listBack = func.copyArr(that.options);
      that.list = func.copyArr(that.options);
    },
    /** 将列表滚动到当前默认选中项（与 row.value == current 一致） */
    scrollToSelected() {
      this.$nextTick(() => {
        const wrap = this.$refs.listScroll;
        if (!wrap) {
          return;
        }
        const active = wrap.querySelector(".shop-item.active");
        if (active) {
          active.scrollIntoView({ block: "center", behavior: "auto" });
        }
      });
    },
    backClick() {
      this.self.isShow = false;
    },
    // 搜索员工姓名方法，支持拼音匹配
    editShopname() {
      // 获取搜索框的内容
      let val = this.searchContent;
      if (val) {
        let result = [];
        this.listBack.forEach((i) => {
          let m = PinyinMatch.match(i.name, val);
          if (!m) {
          } else {
            result.push(i);
          }
        });

        // 将过滤后的数组重新赋给下拉列表数据
        result = this.removeRepet(result, "name");
        this.list = func.copyArr(result);
      } else {
        // 如果输入框为空, 则将下拉列表数据还原
        this.list = this.listBack;
      }
      this.$nextTick(() => this.scrollToSelected());
    },
    clickStore: debounceTool._debounce(function (row) {
      if (row.disabled) {
        return;
      }
      const that = this;
      that.$emit("empChange", {
        row,
      });
      that.backClick();
    }, 200),
    removeRepet(list, key) {
      //根据数组的某个值去重
      let map = new Map();
      list.forEach((item) => {
        if (!map.has(item[key])) map.set(item[key], item);
      });
      return [...map.values()];
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes rightin {
  from {
    transform: translateX(100%);
    /* 初始状态在屏幕右侧外 */
  }

  to {
    transform: translateX(0);
    /* 最终状态向左移动到屏幕内 */
  }
}

/* Your styles for selectStore page go here */
.full-screen-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 8;
  background-color: #f6f6f6;
  animation: rightin 0.3s forwards;
  -webkit-animation: rightin 0.3s forwards;
}

.van-search__action {
  padding: 0 0.833rem;
}

.shoplist {
  padding: 0 0.292rem 0.334rem;
}

.shop-item {
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  /* 控制显示的行数 */
  text-align: left;
  padding: 0.292rem 0.125rem;
  border-bottom: 0.021rem solid #ccc;
  color: #333;
  cursor: pointer;

  &.active {
    color: #28b8c3;
  }

  &.disabled {
    color: #999;
  }
}

.icon-ok {
  font-size: 0.333rem;
  color: #ccc;
  &.active {
    color: #28b8c3;
  }
}

.backBtn {
  border: 1px solid #28b8c3;
  color: #28b8c3;
}

.selectStoreTitle {
  padding: 0.217rem 0.208rem 0.217rem 0.208rem;

  font-size: 0.292rem;
  text-align: left;
  background-color: #fff;
  .backicon {
    font-size: 0.375rem;
    color: #28b8c3;
    padding: 0 0.15rem;
  }
}

.select-title-main {
  min-width: 0;
  text-align: left;
  line-height: 1.4;
}

.title-text {
  color: #333;
}

.title-plain {
  color: #333;
}
.searchbar {
  margin-top: 0.15rem;
}

.listScroll {
  background-color: #fff;
  margin-top: 0.15rem;
}

.titleGeay {
  color: #999;
}
</style>
